<template>
  <div class="card-box">

    <BaseAlert
        :visible=true
        type="info"
        title="Exibe apenas produtos dos últimos 30 dias."
        message="Restritos a rascunhos nesse período."
    />
    <div class="row">
      <!-- Items per page -->
      <div class="col-sm-12 col-md-6 d-flex align-items-center">
        <div class="mr-2 mb-2">Mostrar&nbsp;</div>
        <div class="mr-2 mb-2 p-0">
          <b-form-select
            v-model="perPage"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </div>
        <div class="mr-2 mb-2 p-0">&nbsp;por página</div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6 d-flex justify-content-end align-items-center">
        <div id="tickets-table_filter"
             class="dataTables_filter text-md-right"
        >
          <b-form-input
            v-model="filter"
            type="search"
            placeholder="Pesquisar..."
            class="form-control form-control-sm mb-2"
          ></b-form-input>
          <b-form-group>
              <b-form-select v-model="showDraftObservation" :options="options"  @change="fetchProducts()"></b-form-select>
          </b-form-group>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div v-if="products.length > 0 && !loading"
             class="table-responsive mb-0"
        >
          <b-table
            :items="products"
            :fields="fields"
            responsive="sm"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            sort-icon-left
            :filter-included-fields="filterOn"
          >
            <!-- Seller -->
            <template v-slot:cell(_seller)="data">
              <div class="externclass">
                <div
                  class="classification"
                  :style="setColor(data.item.seller.classification)"
                ></div>
                <p>{{ data.item.seller.name }}</p>
              </div>
              <b v-if="data.item.seller.cpf_cnpj">
                {{ data.item.seller.cpf_cnpj }}
              </b>
              <div v-if="data.item.seller.cellphone">
                <a
                  :href="`https://api.whatsapp.com/send?phone=+55${data.item.seller.cellphone.replace(
                    /[() -]/g,
                    ''
                  )}`"
                  target="_blank"
                ><i class="fab fa-whatsapp"></i>
                  {{ data.item.seller.cellphone }}</a
                ></div
              >
              <div>{{ data.item.seller.email }}</div>
              <NewProgressBar v-if="data.item.seller.score && data.item.seller.score.total_score" :type="'SellerScore'"
                              :valor="data.item.seller.score.total_score"/>

            </template>

            <!-- Name -->
            <template v-slot:cell(name)="data">
              <div v-if="data.item  && data.item.is_first_product"
                   class="bg-success rounded flagFirstProduct  text-center text-white">PRIMEIRO PRODUTO
              </div>
              {{ data.item.name }}
              <i  v-if="data.item  && data.item.draft_observation" 
                  v-b-tooltip.hover :title="data.item.draft_observation"
                  class="fas fa-info-circle">
              </i>
            </template>

            <!-- Amount -->
            <template v-slot:cell(amount)="data">
              <span v-if="data.item.offers">
                {{ data.item.offers[0].local_currency.currency_symbol }} {{ formatMoney(data.value) }}
              </span>
            </template>
            <!-- Type -->
            <template v-slot:cell(type)="data">
              {{
                data.value === 'TRANSACTION'
                  ? 'Valor único'
                  : 'Assinatura'
              }}
            </template>
            <!-- Local Currency -->
            <template v-slot:cell(currency)="data">
              <span v-if="data.item.offers">
                {{ data.item.offers[0].local_currency.name }}
              </span>
            </template>
            <!-- Creation Date  -->
            <template v-slot:cell(created_at)="data">
              {{ data.value | datetime }}
            </template>
            <!-- Actions -->
            <template v-slot:cell(_actions)="data">
              <div v-if="!attendance && !success" class="actions">
                <!-- Approve Product -->
                <b-button
                  v-if="canShowApproveButton"
                  v-b-tooltip.hover title="Aprovar produto"
                  variant="success"
                  @click="acceptProduct(data.item)"
                >
                  <i class="fas fa-check"></i>
                </b-button>
                <!-- Info User and Product -->
                <b-button
                  v-b-tooltip.hover title="Informações do usuário e do produto"
                  :disabled="!canViewProductDetails"
                  variant="dark"
                  @click="detail(data.item)"
                >
                  <i class="fas fa-info-circle"></i>
                </b-button>
                <!-- Login -->
                <b-button
                  v-if="canShowLogin"
                  v-b-tooltip.hover title="Fazer login"
                  variant="info"
                  @click="login(data.item.seller.id)"
                >
                  <i class="fas fa-sign-in-alt"></i>
                </b-button>
                <!-- Info User and Product -->
                <b-button
                  v-if="canShowObservation"
                  v-b-tooltip.hover title="Observação de Tratativa"
                  variant="warning"
                  @click="open_draft_observation(data.item)"
                >
                  <i class="fas fa-edit"></i>
                </b-button>

              <b-button
                v-if="canDeleteProduct"
                v-b-tooltip.hover title="Apagar produto"
                variant="danger"
                @click="productDelete(data.item)"
              >
                <i class="fas fa-trash-alt"></i>
              </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <!--Pagination -->
    <div v-if="products.length > 0" class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <!-- Feedback Menssage -->
    <div v-if="products.length === 0 && !loading"
         class="row justify-content-center"
    >
      <div class="alert alert-primary" role="alert">
        Sem produtos pendentes.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ProductService from '@services/resources/ProductService'
import DraftObservationService from '@services/resources/DraftObservationService'
import Money from '@src/mixins/money'
import _ from 'lodash'
import Graph from '@router/views/analysis/graph.vue'
import validAcessRoute from '@/src/utils/validAcessRoute'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import { statusEnum } from "./enums/statusEnum.js";
import BaseAlert from "@views/ui/BaseAlert.vue";
import FoundSearchMixin from "@views/products/mixins/FoundSearchMixin";
import {AccessLevel} from "@views/configurations/enums/accessLevel";

var service = ProductService.build()

var serviceDraftObservation = DraftObservationService.build()

export default {
  name: "TableProductsDraft",
  components: {Graph, NewProgressBar, BaseAlert},
  mixins: [Money, FoundSearchMixin],
  props: {
    coins: {
      required: true,
      type: Array,
      default: () => []
    },
    activeTab: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      currentPage: 1,
      dataUser: {},
      statusEnum,
      loading: true,
      productsLoaded: false,
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: '_seller', label: 'Vendedor', sortable: true},
        {key: 'name', label: 'Produto', sortable: false},
        {key: 'amount', label: 'Valor', sortable: true},
        {key: 'type', label: 'Tipo', sortable: false},
        {key: 'created_at', label: 'Data de Criação', sortable: false},
        {key: '_actions', label: 'Ações', sortable: false,  thClass: 'text-center'},
      ],
      filter: '',
      filterOn: [],
      filters: {},
      products: [],
      pageOptions: [20, 50, 100],
      perPage: 20,
      selectedCurrency: null,
      sortBy: 'name',
      sortDesc: false,
      totalRows: 1,
      total: 0,
      // Actions Validations
      financial: validAcessRoute(['financial'], this.$store.getters.getProfile),
      risco: validAcessRoute(['risk'], this.$store.getters.getProfile),
      attendance: validAcessRoute(['attendance'], this.$store.getters.getProfile),
      success: validAcessRoute(['success'], this.$store.getters.getProfile),
      financialManager: validAcessRoute(['financialManager'], this.$store.getters.getProfile),
      financialAssistant: validAcessRoute(['financialAssistant'], this.$store.getters.getProfile),
      compliance: validAcessRoute(['compliance'], this.$store.getters.getProfile),
      showDraftObservation: false,
      options:  [
          { value: false, text: 'Não Revisados' },
          { value: true, text: 'Revisados' },
      ]
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canAcceptProduct() {
      const isNonFinancial = !this.financial && !this.risco && !this.financialAssistant;
      return isNonFinancial || this.financialManager || this.compliance;
    },
    canShowApproveButton() {
      if (this.useActionPermissions) {
        return this.$canAction('products_approve_button', AccessLevel.EDITOR);
      }
      
      return this.canAcceptProduct;
    },
    canShowLogin() {
      if (this.useActionPermissions) {
        return this.$canAction('products_login_button', AccessLevel.EDITOR)
      }

      return !this.financialAssistant && !this.risco
    },
    canShowObservation() {
      if (this.useActionPermissions) {
        return this.$canAction('products_observation_button', AccessLevel.EDITOR)
      }

      return !this.showDraftObservation;
    },
    canViewProductDetails() {
      if (this.useActionPermissions) {
        return this.$canAction('products_show_details', AccessLevel.READER)
      }
      return true;
    },
    canDeleteProduct() {
      if (this.useActionPermissions) {
        return this.$canAction('products_delete_button', AccessLevel.EDITOR)
      }
      return this.canAcceptProduct;
    },
  },
  created() {
    // As this is the first table to load, we need to fetch the products here
    this.fetchProducts()
  },
  watch: {
    currentPage() {
      this.fetchProducts()
    },
    perPage() {
      this.fetchProducts()
    },
    filter() {
      this.debounce()
    },
    activeTab(val) {
      // if tab is active, fetch products
      if (val === 'draft' && !this.productsLoaded) {
        this.applyFoundSearch()
        this.fetchProducts()
      }
    }
  },
  methods: {
    /**
     * Set color in style dot before seller name on table depending on seller classification
     * @param color - String
     * @return String - css style background color
     * @author Sandro Souza
     */
    setColor(color) {
      if (color) {
        switch (color) {
          case 'green':
            return 'background: #00E4A0'
          case 'yellow':
            return 'background: #fff700'
          case 'red':
            return 'background: #FF0A44'
          case 'black':
            return 'background: #000000'
          default:
            return 'background:#c7c7c7;'
        }
      }
    },
    /**
     * Filter table data
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    debounce: _.debounce(function () {
      this.fetchProducts()
    }, 500),
    /**
     * Brings all products, or only filtered products. It feed the table.
     * @param filters - Object
     * @return no return
     * @author Sandro Souza
     */
    fetchProducts(filters = {}) {
      this.loading = true
      this.products = []
      let currency = this.isHeaven ? 'USD' : 'BRL'
      // let currency = null;
      // if(this.selectedCurrency) currency = this.selectedCurrency.currency

      let data = {
        per_page: this.perPage,
        page: this.currentPage,
        status: 'DRAFT',
        showDraftObservation: this.showDraftObservation
      };

      if (currency != null) {
        data.currency = currency;
      }

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.filter.length) data.search = this.filter

      service
        .search(data)
        .then((resp) => {
          this.products = resp.data
          this.totalRows = resp.total
          this.total = resp.total
          this.productsLoaded = true
          this.$store.dispatch(
              'updateFoundInStatuses',
              resp.found_in_status || []
          )
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.productsLoaded = false;
          this.loading = false
        });
    },
    /**
     * Open SweetAlert2 to refuse product
     * @param dados - Array
     * @return no return
     * @author Sandro Souza
     */
    /**
     * Open details modal. Send "dataUser" for parent component (./list.vue) that imported details modal.
     * @param dataUser - Object
     * @return no return
     * @author Sandro Souza
     */
    detail(dataUser) {
      this.$emit('open-detail', dataUser.id)
    },
    /**
     * Redirects user to another tab in browser to login to adm.
     * @param id - Number
     * @return no return
     * @author Sandro Souza
     */
    login(id) {
      let url = (this.isHeaven ? process.env.VUE_APP_HEAVEN_ADM_PAGE : process.env.VUE_APP_ADM_PAGE) + '/admin-login/' + btoa(id)
      window.open(url)
    },
    open_draft_observation(item) {
      Vue.swal({
        title: 'Observação de Tratativa',
        text: 'Após contato com o vendedor, descreva em até 255 caracteres o que foi tratado',
        type: 'warning',
        input: 'textarea',
        inputAttributes: {
          autocapitalize: 'off',
          maxlength: '255',
          rows: 5
        },
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            product_id: item.id,
            text: result.value
          }

         serviceDraftObservation
            .create(data)
            .then((resp) => {
              this.fetchProducts()
            })
            .catch(err => console.error(err))
        }
      })
    },
    isSwalOutAction(action) {
      return ['cancel', 'backdrop'].includes(action);
    },
    validateProductDataToAccept(product) {
      if(!product.name.trim().length){
        this.$bvToast.toast('O produto deve possuir um nome', {
          title: 'Aprovação de produto',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        });
        throw new Error('Missing name');
      }

      if(!product.amount){
        this.$bvToast.toast('O produto deve possuir um valor', {
          title: 'Aprovação de produto',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        });
        throw new Error('Missing amount');
      }
    },
    disptachSwalToAcceptProduct(product) {
      Vue.swal({
        title: 'Aprovar produto',
        text: 'Tem certeza que deseja aprovar esse produto em rascunho?',
        type: 'warning',
        input: 'checkbox',
        inputValue: 1,
        inputPlaceholder: 'Será mostrado na vitrine caso o produtor desejar',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (!this.isSwalOutAction(result.dismiss)) {
          let data = {
            id: product.id,
            format: product.format,
            status: this.statusEnum.APPROVED,
            is_public_allowed: result.value === 1,
          }
          service
            .update(data)
            .then(() => {
              this.$bvModal.hide('details')
              this.fetchProducts()
            })
            .catch(err => console.error(err))
        }
      });
    },
    acceptProduct(product) {
      this.validateProductDataToAccept(product);
      this.disptachSwalToAcceptProduct(product);
      this.$emit('update-accept-for-approval')
    },
    productDelete(item) {
      Vue.swal({
        title: 'Confirmar exclusão',
        text: 'Tem certeza que deseja deletar esse produto ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Deletar',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn mt-2 mr-2',
        cancelButtonClass: 'btn mt-2',
        buttonsStyling: true,
        reverseButtons: true,
        }).then((result) => {
        if (result.value === true) {
          service.destroy(item.id)
            .then(() => {
              this.$bvToast.toast('Produto deletado com sucesso.', {
                title: 'Sucesso',
                variant: 'success',
                autoHideDelay: 5000,
                appendToast: true,
              });
              this.fetchProducts();
            })
            .catch(err => {
              console.error(err);
              this.$bvToast.toast('Erro ao deletar produto.', {
                title: 'Erro',
                variant: 'danger',
                autoHideDelay: 5000,
                appendToast: true,
              });
            });
        }
      });
    }
  }
}
</script>

<style scoped>

.b-table .actions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
  padding-bottom: 0;
}

.actions .btn {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.actions .btn i {
  font-size: 18px;
}

.card-box {
  border-radius: 0 0 3px 3px;
}

.flagFirstProduct {
  font-size: 8px;
  width: 40%;
}
</style>
